module.exports = __webpack_public_path__ + "static/media/class_job_025.79d1d0fa.svg";